// src/components/Journey/JourneySection.js
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Journey.css';
import JourneyImg from "../../assets/Home/Journey.png"; // Renamed variable to avoid conflict

const JourneySection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="journey-section" id="journey">
      <Container>
        {/* MAIN CONTENT ROW */}
        <Row className="align-items-center">
          
          {/* Left Column: Image */}
          <Col lg={6} md={12}>
            <div className="journey-img-wrapper" data-aos="fade-right">
              <img 
                src={JourneyImg}
                alt="Factory Floor 2010" 
                className="journey-img" 
              />
            </div>
          </Col>

          {/* Right Column: Text Content */}
          <Col lg={6} md={12}>
            <div className="journey-content" data-aos="fade-left">
              {/* The Watermark Number */}
              <div className="watermark-year">2010</div>

              <span className="section-subtitle">Our Journey & Milestones</span>
              <h2 className="journey-heading">
                A Journey of Precision<br />Manufacturing Excellence
              </h2>
              
              <p className="journey-desc">
                Since our inception, we have steadily expanded our manufacturing
                capabilities, infrastructure, and quality systems to support the
                growing requirements of automotive OEMs and industrial customers.
                Our journey reflects continuous improvement and a long-term
                commitment to precision, quality, and reliability.
              </p>
            </div>
          </Col>
        </Row>

        {/* TIMELINE ROW */}
        <div className="timeline-container" data-aos="fade-up" data-aos-delay="200">
          <div className="timeline-line"></div>

          {/* 2008 */}
          <div className="timeline-item">
            <span className="timeline-year">2008</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2010 (ACTIVE) */}
          <div className="timeline-item active">
            <span className="timeline-year">2010</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2013 */}
          <div className="timeline-item">
            <span className="timeline-year">2013</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2015 */}
          <div className="timeline-item">
            <span className="timeline-year">2015</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2018 */}
          <div className="timeline-item">
            <span className="timeline-year">2018</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2020 */}
          <div className="timeline-item">
            <span className="timeline-year">2020</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2023 */}
          <div className="timeline-item">
            <span className="timeline-year">2023</span>
            <div className="timeline-dot"></div>
          </div>

          {/* 2025 */}
          <div className="timeline-item">
            <span className="timeline-year">2025</span>
            <div className="timeline-dot"></div>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default JourneySection;